export default __webpack_public_path__ + "static/media/DFS_Soccer.9da258be.webp";